
//quantity

document.addEventListener("click", function (event) {
    if (event.target.matches(".quantity-increase")) {
      let input = event.target.closest(".side-cart-item__quantity").querySelector(".quantity-input");
      input.value = parseInt(input.value) + 1;
      input.dispatchEvent(new Event("change"));
    }
  
    if (event.target.matches(".quantity-decrease")) {
      let input = event.target.closest(".side-cart-item__quantity").querySelector(".quantity-input");
      if (parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
        input.dispatchEvent(new Event("change"));
      }
    }
  });
  
  function updateMainImageOnVariantChange() {
    const radios = document.querySelectorAll('input[name="id"]');
    radios.forEach(radio => {
      radio.addEventListener('change', function() {
        const imageId = this.dataset.imageId;
        if (!imageId) return;
  
        // Slide main image
        const mainImages = document.querySelectorAll('.main-slider img');
        const index = Array.from(mainImages).findIndex(img => img.dataset.imageId === imageId);
        if (index >= 0) mainSlider.slideTo(index);
  
        // Update thumbnails
        const thumbnails = document.querySelectorAll('.thumbnail-slider .thumbnail-image');
        thumbnails.forEach(img => img.classList.remove('active'));
        const activeThumb = document.querySelector(`.thumbnail-slider .thumbnail-image[data-image-id="${imageId}"]`);
        if (activeThumb) activeThumb.classList.add('active');
      });
    });
  }
  
  document.addEventListener('DOMContentLoaded', function () {
    // Thumbnail Swiper
    const thumbSlider = new Swiper('.thumbnail-slider', {
      direction: window.innerWidth > 768 ? 'vertical' : 'horizontal',
      spaceBetween: 6,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      mousewheel: true,
    });

    // Main Swiper
    const mainSlider = new Swiper('.main-slider', {
      spaceBetween: 10,
      // autoHeight: true,
      thumbs: { swiper: thumbSlider },
    });

    // Thumbnail click → update main image
    document.querySelectorAll('.thumbnail-image').forEach(img => {
      img.addEventListener('click', function () {
        const id = this.getAttribute('data-image-id');
        const index = [...document.querySelectorAll('.main-image')]
          .findIndex(el => el.getAttribute('data-image-id') === id);
        if (index !== -1) {
          mainSlider.slideTo(index);
        }
      });
    });

    // Variant change → main image update
    document.querySelectorAll('[name="id"]').forEach(select => {
      select.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantImageId = selectedOption.getAttribute('data-image-id');
        if (variantImageId) {
          const index = [...document.querySelectorAll('.main-image')]
            .findIndex(img => img.getAttribute('data-image-id') === variantImageId);
          if (index !== -1) {
            mainSlider.slideTo(index);
          }
        }
      });
    });

    // Resize → vertical ↔ horizontal switch
    window.addEventListener('resize', () => {
      thumbSlider.changeDirection(window.innerWidth > 768 ? 'vertical' : 'horizontal');
    });
  });

  function updateLayout() {
    const container = document.querySelector('.product-page-container');
    if (!container) return;
  
    const productInner = container.querySelector('.product-inner');
    const mainSliderEl = container.querySelector('.swiper.main-slider');
  
    // Determine layout
    const layoutSetting = container.dataset.layout || (container.classList.contains('thumbnail_carousel') ? 'thumbnail_carousel' : 'columns');
    const stacked = container.dataset.stacked === 'true'; // check stacked
  
    if (layoutSetting === 'columns') {
      container.classList.add('grid-container');
      if (productInner) productInner.classList.add('two-column');
    } else {
      container.classList.remove('grid-container');
      if (productInner) productInner.classList.remove('two-column');
    }
  
    if (mainSliderEl && mainSliderEl.swiper) {
      setTimeout(() => {
        mainSliderEl.swiper.params.slidesPerView = stacked ? 1 : (layoutSetting === 'columns' ? 2 : 1);
        mainSliderEl.swiper.update();
      }, 50);
    }
  }
  
  // Run on page load
  document.addEventListener('DOMContentLoaded', updateLayout);
  
  // Shopify editor events
  ['shopify:section:select','shopify:section:unselect','shopify:section:load','shopify:section:reorder'].forEach(evt => {
    document.addEventListener(evt, updateLayout);
  });
  
  // Observe changes in data-layout and data-stacked dynamically
  const container = document.querySelector('.product-page-container');
  if (container) {
    const observer = new MutationObserver(() => updateLayout());
    observer.observe(container, { attributes: true, attributeFilter: ['data-layout', 'data-stacked'] });
  }
  
  
  
  //zoom
  function initProductZoom() {
    const productImages = document.querySelectorAll(".product-image");
  
    productImages.forEach(img => {
      const container = img.closest(".product-page-container");
  
      // Remove previous events to avoid duplicates
      img.replaceWith(img.cloneNode(true));
    });
  
    // Re-query after cloning to avoid duplicate events
    const images = document.querySelectorAll(".product-image");
  
    images.forEach(img => {
      const container = img.closest(".product-page-container");
  
      // HOVER + CLICK
      if (container.classList.contains("zoom-mode-hover_click")) {
        let zoomed = false;
  
        // Hover zoom
        img.addEventListener("mouseover", () => {
          if (!zoomed) {
            img.style.transform = "scale(1.2)";
            img.style.transition = "transform 0.3s ease";
          }
        });
  
        img.addEventListener("mouseout", () => {
          if (!zoomed) {
            img.style.transform = "scale(1)";
          }
        });
  
        // Click zoom toggle
        img.addEventListener("click", () => {
          zoomed = !zoomed;
  
          if (zoomed) {
            img.classList.add("zoomed-img");
            img.style.transform = "scale(2)";
            img.style.cursor = "zoom-out";
          } else {
            img.classList.remove("zoomed-img");
            img.style.transform = "scale(1)";
            img.style.cursor = "zoom-in";
          }
        });
      }
  
      // LIGHTBOX
      if (container.classList.contains("zoom-mode-lightbox")) {
        img.addEventListener("click", () => {
          const lightbox = document.createElement("div");
          lightbox.className = "lightbox";
          lightbox.innerHTML = `
            <div class="lightbox-content">
              <button class="lightbox-close">×</button>
              <img src="${img.dataset.full}" class="lightbox-img">
            </div>
          `;
          document.body.appendChild(lightbox);
  
          lightbox.querySelector(".lightbox-close").addEventListener("click", () => {
            lightbox.remove();
          });
        });
      }
    });
  }
  
  // Initial run
  document.addEventListener("DOMContentLoaded", initProductZoom);
  
  // Re-run when Shopify editor settings change live
  document.addEventListener('shopify:section:select', initProductZoom);
  document.addEventListener('shopify:section:load', initProductZoom);
  document.addEventListener('shopify:section:unload', initProductZoom);
  document.addEventListener('shopify:section:reorder', initProductZoom);
  
  
  const variantsData = JSON.parse(document.getElementById('product-variants-json').textContent);
  
  function updateVariantId() {
    const selectedOptions = [];
    document.querySelectorAll('.variant-option').forEach((option, i) => {
      const pills = option.querySelector('.variant-pills input:checked');
      const dropdown = option.querySelector('.variant-dropdown');
      const value = pills ? pills.value : dropdown.value;
      selectedOptions.push(value);
    });
  
    const match = variantsData.find(v => v.options.every((o, i) => o === selectedOptions[i]));
    if(match) document.querySelector('.selected-variant-id').value = match.id;
  }
  
  document.querySelectorAll('.variant-pills input').forEach(input => input.addEventListener('change', updateVariantId));
  document.querySelectorAll('.variant-dropdown').forEach(select => select.addEventListener('change', updateVariantId));
  
  
  document.querySelectorAll('.share-button').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.nextElementSibling;
      input.style.display = 'block';
      input.select();
      input.setSelectionRange(0, 99999); // For mobile devices
      document.execCommand('copy'); // Copy the link
      button.textContent = 'Link Copied!';
      setTimeout(() => {
        button.textContent = button.dataset.originalText || 'Share this product';
        input.style.display = 'none';
      }, 2000);
    });
  
    // Store original text for reset
    button.dataset.originalText = button.textContent;
  });
  
  
  